import React, { useCallback, useEffect, useState } from 'react';
import OurAccordion from '../../../../../../_elements/OurAccordion';
import CategoryItem from './components/CategoryItem';
import { fetchWrapper } from '../../../../../../_helpers';
import { VscLoading } from 'react-icons/vsc';
import styled from '@emotion/styled';
import { Button } from 'react-bootstrap';
import CategoryModal from './components/CategoryModal';

function Categories() {
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [type, setType] = useState('all');
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    };

    const getCategories = useCallback(async () => {
        // api call to fetch categories
        try {
            setIsLoading(true);
            if (type === 'manager') {
                setCategories([]);
            } else {
                const response = await fetchWrapper.get(`pins${type === 'premium' ? '?premium=true' : ''}`);
                setCategories(response.results);
            }
            setIsLoading(false);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    }, [type]);

    useEffect(() => {
        if (show === false) {
            getCategories();
        }
    }, [getCategories, show]);

    const handleTypeChange = (type) => {
        setType(type);
    };

    const handleEdit = (category) => {
        setShow(category);
    };

    const handleDelete = async (categoryId) => {
        try {
            let confirm = window.confirm('Are you sure?');
            if (confirm) {
                await fetchWrapper.delete(`pins/${categoryId}`);
                getCategories();
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <OurAccordion title="Categories">
            <div className="d-flex justify-content-between">
                <div className="d-flex ">
                    <Tab active={type === 'all' ? true : false} onClick={() => handleTypeChange('all')}>
                        All
                    </Tab>
                    <Tab active={type === 'premium' ? true : false} onClick={() => handleTypeChange('premium')}>
                        Premium
                    </Tab>
                    {/* <Tab active={type === 'manager' ? true : false} onClick={() => handleTypeChange('manager')}>
						Managerial
					</Tab> */}
                </div>

                <Button className="mr-2" variant="dark" onClick={() => setShow(true)}>
                    Create Category
                </Button>
            </div>
            <hr />
            <div className="row">
                {isLoading ? (
                    <div className="d-flex justify-content-center m-4 w-100	">
                        <VscLoading className="spin" fontSize="34" />
                    </div>
                ) : (
                    categories.map((category) => (
                        <CategoryItem
                            key={category._id}
                            category={category}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                        />
                    ))
                )}
            </div>
            {show && <CategoryModal show={show} handleClose={handleClose} />}
        </OurAccordion>
    );
}

export default Categories;

const Tab = styled.div`
    margin: 5px 7px;
    padding: 5px 7px;
    border: 1px solid gray;
    border-radius: 5px;
    background-color: ${(props) => (props.active ? '#50aeb0' : 'transparent')};
    color: ${(props) => (props.active ? '#fff' : '#333')};
    cursor: pointer;
`;
